export var EOrderBookAifPmsStatus;
(function (EOrderBookAifPmsStatus) {
    EOrderBookAifPmsStatus["CXO_ORDER_REJECTED"] = "CXO Rejected";
    EOrderBookAifPmsStatus["LOB_HEAD_ORDER_REJECTED"] = "Lob Head Approval Rejected";
    EOrderBookAifPmsStatus["QC_ORDER_PENDING"] = "QC Process Pending";
    EOrderBookAifPmsStatus["CXO_ORDER_PENDING"] = "CXO Approval Pending";
    EOrderBookAifPmsStatus["ORDER_INPROGRESS"] = "Order in Progress";
    EOrderBookAifPmsStatus["ORDER_COMPLETED"] = "Completed";
    EOrderBookAifPmsStatus["LOB_HEAD_ORDER_PENDING"] = "Lob Head Approval Pending";
})(EOrderBookAifPmsStatus || (EOrderBookAifPmsStatus = {}));
export var EKebebMenuItemsAIFPMS;
(function (EKebebMenuItemsAIFPMS) {
    EKebebMenuItemsAIFPMS["MODIFY"] = "Modify SB Details";
    EKebebMenuItemsAIFPMS["ADD"] = "Add SB Details";
    EKebebMenuItemsAIFPMS["VIEW_DETAILS"] = "View Details";
    EKebebMenuItemsAIFPMS["CANCEL"] = "Cancel Order";
    EKebebMenuItemsAIFPMS["EDIT"] = "Edit";
})(EKebebMenuItemsAIFPMS || (EKebebMenuItemsAIFPMS = {}));
